import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Home2 from '../views/Home2.vue'
import Login from '../views/Login.vue'

const routes = [
  {
    path: '/locus',
    name: 'Locus',
    component: () => import('../views/map/Locus.vue')
  },
  {
    path: '/map',
    name: 'Map',
    component: () => import('../views/map/Map.vue')
  },
  {
    path: '/',
    name: 'Cacl',
    component: () => import('../views/cacl/Cacl.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/home2',
    name: 'Home2',
    component: Home2
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../views/code/Test.vue')
  },
  {
    path: '/code',
    name: 'code',
    component: () => import('../views/code/Code.vue')
  },
  {
    path: '/ccode',
    name: 'ccode',
    component: () => import('../views/code/CustomerCode.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/xy',
    name: 'xy',
    component: () => import('../views/Xy.vue')
  },
  {
    path: '/calc',
    name: 'calc',
    component: () => import('../views/calculator/Calc.vue')
  },
  {
    path: '/calcday',
    name: 'calcday',
    component: () => import('../views/calculator/CalcDay.vue')
  },
  {
    path: '/calcirr',
    name: 'calcirr',
    component: () => import('../views/calculator/CalcIrr.vue')
  },
  {
    path: '/calcback',
    name: 'calcback',
    component: () => import('../views/calculator/CalcBack.vue')
  },
  {
    path: '/shop',
    name: 'shop',
    component: () => import('../views/shop/Shop.vue')
  },
  {
    path: '/shopdetail',
    name: 'shopdetail',
    component: () => import('../views/shop/ShopDetail.vue')
  },
  {
    path: '/shopproduct',
    name: 'shopproduct',
    component: () => import('../views/shop/ShopProduct.vue')
  },
  {
    path: '/share',
    name: 'share',
    component: () => import('../views/share/Share.vue')
  },
  {
    path: '/shopedit',
    name: 'shopedit',
    component: () => import('../views/shop/ShopEdit.vue')
  },
  {
    path: '/customer',
    name: 'customer',
    component: () => import('../views/customer/Customer.vue')
  },
  {
    path: '/customerlist',
    name: 'customerlist',
    component: () => import('../views/customer/CustomerList.vue')
  },
  {
    path: '/customerflow',
    name: 'customerflow',
    component: () => import('../views/customer/CustomerFlow.vue')
  },
  {
    path: '/orderadd',
    name: 'orderadd',
    component: () => import('../views/order/OrderAdd.vue')
  },
  {
    path: '/orderadd2',
    name: 'orderadd2',
    component: () => import('../views/order/OrderAdd2.vue')
  },
  {
    path: '/ordershareadd',
    name: 'ordershareadd',
    component: () => import('../views/order/OrderShareAdd.vue')
  },
  {
    path: '/orderdetail',
    name: 'orderdetail',
    component: () => import('../views/order/OrderDetail.vue')
  },
  {
    path: '/orderdetail2',
    name: 'orderdetail2',
    component: () => import('../views/order/OrderDetail2.vue')
  },
  {
    path: '/me',
    name: 'me',
    component: () => import('../views/me/Me.vue')
  },
  {
    path: '/meedit',
    name: 'meedit',
    component: () => import('../views/me/MeEdit.vue')
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('../views/account/Account.vue')
  },
  {
    path: '/cashout',
    name: 'cashout',
    component: () => import('../views/account/CashOut.vue')
  },
  {
    path: '/income',
    name: 'income',
    component: () => import('../views/account/Income.vue')
  },
  {
    path: '/vip',
    name: 'vip',
    component: () => import('../views/vip/Vip.vue')
  },
  {
    path: '/set',
    name: 'set',
    component: () => import('../views/set/Set.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about/About.vue')
  },
  {
    path: '/team',
    name: 'team',
    component: () => import('../views/team/Team.vue')
  },
  {
    path: '/match',
    name: 'match',
    component: () => import('../views/match/Match.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/search/Search.vue')
  },
  {
    path: '/companysearch',
    name: 'companysearch',
    component: () => import('../views/match/CompanySearch.vue')
  },
  {
    path: '/companyresult',
    name: 'companyresult',
    component: () => import('../views/match/CompanyResult.vue')
  },
  {
    path: '/matchadd',
    name: 'matchadd',
    component: () => import('../views/match/MatchAdd.vue')
  },
  {
    path: '/matchexpert',
    name: 'matchexpert',
    component: () => import('../views/match/MatchExpert.vue')
  },
  {
    path: '/matchexperttip',
    name: 'matchexperttip',
    component: () => import('../views/match/MatchExpertTip.vue')
  },
  {
    path: '/producttable',
    name: 'producttable',
    component: () => import('../views/product/ProductTable.vue')
  },
  {
    path: '/productlist',
    name: 'productlist',
    component: () => import('../views/product/ProductList.vue')
  },
  {
    path: '/productdetail',
    name: 'productdetail',
    component: () => import('../views/product/ProductDetail.vue')
  },
  {
    path: '/schemeadd',
    name: 'schemeadd',
    component: () => import('../views/scheme/SchemeAdd.vue')
  },
  {
    path: '/schemeloading',
    name: 'schemeloading',
    component: () => import('../views/scheme/SchemeLoading.vue')
  },
  {
    path: '/matchresult',
    name: 'matchresult',
    component: () => import('../views/match/MatchResult.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  // history: createWebHashHistory(),
  history:createWebHistory(),
  routes
})

export default router
